import { render } from 'preact';
import { App } from './app.tsx';
import { model } from './model.ts';
import { Syncer } from './sync.ts';
import { initAudio } from './audio.ts';
import { registerServiceWorker } from './sw-client.ts';
import './styles.css';

const syncer = new Syncer(model);

// After answering, wait a little so a run of answers goes up in one request;
// after editing a card or deck, go almost at once so the server can start its audio.
model.onLocalChange = (kind) => syncer.schedule(kind === 'review' ? 15_000 : 1000);

async function start() {
  render(<App syncer={syncer} />, document.getElementById('app')!);
  await model.load();
  initAudio(model.db);

  // A sign-in link (https://…/#token=…) saves the token and drops it from the URL.
  const m = /[#&]token=([^&]+)/.exec(location.hash);
  if (m) {
    await model.setToken(decodeURIComponent(m[1]));
    history.replaceState(null, '', location.pathname);
  }
  if (model.token) void navigator.storage?.persist?.();

  void syncer.run();
  addEventListener('online', () => void syncer.run());
  document.addEventListener('visibilitychange', () => {
    // Leaving the app is the moment to get answers off the device.
    if (document.visibilityState === 'hidden') {
      if (model.sync.pending) void syncer.run();
    } else {
      syncer.schedule(500);
    }
  });
  setInterval(() => {
    if (document.visibilityState === 'visible') void syncer.run();
  }, 5 * 60_000);

  void registerServiceWorker().catch((e) => console.error('service worker', e));
}

void start();
